<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<form
  class="modal-form"
  [formGroup]="categoryForm"
  *ngIf="categoryForm"
  (ngSubmit)="submit()"
  id="form"
>
  <div class="integrity-form-card__body">
    <div class="integrity-form-field integrity-form-field--full">
      <label for="integrityCategoryName" class="integrity-form-label">
        Nome da Categoria <span class="integrity-form-required">*</span>
      </label>
      <input
        id="integrityCategoryName"
        type="text"
        pInputText
        pInputTextarea
        autocomplete="off"
        class="integrity-form-input"
        formControlName="integrityCategoryName"
      />
      <small
        *ngIf="isInvalid('integrityCategoryName')"
        class="integrity-form-error"
      >
        Campo obrigatorio.
      </small>
    </div>

    <div class="integrity-form-actions integrity-form-field--full">
      <button
        pButton
        type="button"
        class="p-button-text"
        label="Cancelar"
        (click)="saved.emit()"
        [disabled]="loading"
      ></button>
      <button
        pButton
        type="submit"
        [label]="isEdit ? 'Salvar alteracoes' : 'Criar Categoria'"
        [disabled]="loading"
      ></button>
    </div>
  </div>

  <div class="integrity-form-card__overlay" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
</form>
